module.exports = __webpack_public_path__ + "img/cre001.0cc078b3.png";